import React from 'react';
import './About.css';

const About = () => {
  return (
    <div className="page-container">
      <h1>About Me</h1>
      <p>
        Hi, I'm Ivy Makokha — a passionate software developer who loves turning ideas into scalable and beautiful solutions.
        I specialize in building web applications using technologies like React, Django, and Flutter.
      </p>
    </div>
  );
};

export default About;
